/**
 * Superadmin email allowlist (frontend mirror of stagery-api's
 * lib/auth/superadminAllowlist.js). Backend remains the security gate;
 * this list only drives MFA-enforcement UX (Phase 10 D-05).
 *
 * If you add/remove an email here, update lib/auth/superadminAllowlist.js
 * in stagery-api in the same change.
 */
export const SUPERADMIN_EMAILS: readonly string[] = [
  'sam@samfeldt.com',
  'nick@velten.group',
  'bas@basgosewisch.com',
] as const;

export function isSuperadminEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return SUPERADMIN_EMAILS.includes(email.toLowerCase() as (typeof SUPERADMIN_EMAILS)[number]);
}
